import React, { Component } from 'react';
import {
    Button, Navbar, NavbarBrand, Nav, NavItem,
    UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import {
    Search, Package, Route, Newspaper, User,
    MessageCircle, LogOut, X, Menu,
} from '../icons';
import NotificationMessage from './common/NotificationMessageComponent';
import { Link } from 'react-router-dom';

const iconStyle = { verticalAlign: 'middle', marginRight: 6 };

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = { hideNav: false, isMenuOpen: false };
        this.handleLogout = this.handleLogout.bind(this);
        this.toggleMenu   = this.toggleMenu.bind(this);
        this.closeMenu    = this.closeMenu.bind(this);
    }

    componentDidMount()   { window.addEventListener('resize', this.resize.bind(this)); this.resize(); }
    componentWillUnmount(){ window.removeEventListener('resize', this.resize.bind(this)); }

    resize() {
        const hide = window.innerWidth <= 760;
        if (hide !== this.state.hideNav) this.setState({ hideNav: hide });
    }
    handleLogout() { this.props.logout(); this.closeMenu(); }
    toggleMenu()   { this.setState(s => ({ isMenuOpen: !s.isMenuOpen })); }
    closeMenu()    { this.setState({ isMenuOpen: false }); }

    render() {
        if (window.location.pathname.split('/')[1] === 'messages' && window.location.pathname.split('/')[2] !== undefined)
            return null;

        const user = JSON.parse(localStorage.getItem('user'));
        const { hideNav, isMenuOpen } = this.state;

        /* ── Desktop dropdown ── */
        const DesktopUserMenu = () => {
            if (!user) return (
                <>
                    <NavItem>
                        <Link className="nav-link" to="/register">
                            <Button className="btn-header" color="primary">Inscription</Button>
                        </Link>
                    </NavItem>
                    <NavItem>
                        <Link className="nav-link" to="/login">
                            <Button className="btn-header" color="primary">Connexion</Button>
                        </Link>
                    </NavItem>
                </>
            );

            const ic = { size: 16, style: iconStyle };

            return (
                <NavItem>
                    <UncontrolledButtonDropdown>
                        <DropdownToggle caret className="text-nowrap bg-transparent border-0 nav-link" style={{ color: '#55575b', display: 'flex', alignItems: 'center', gap: 8 }}>
                            <img className="user-avatar rounded-circle" src="/assets/images/profil.svg" alt="avatar" height="33" width="33" />
                            <sup style={{ position: 'relative', top: 0, left: 0 }}>
                                <NotificationMessage isLoading={this.props.isLoading} notifications={this.props.notifications} />
                            </sup>
                            <strong style={{ color: '#32325d' }}>{user.user.firstName} {user.user.lastName}</strong>
                        </DropdownToggle>
                        <DropdownMenu right>
                            <Link to="/profil" className="inheritLinkColor">
                                <DropdownItem>
                                    <User {...ic} /> Profil
                                </DropdownItem>
                            </Link>
                            <DropdownItem divider />
                            <Link to="/mytrips" className="inheritLinkColor">
                                <DropdownItem><Route {...ic} /> Mes trajets</DropdownItem>
                            </Link>
                            <Link to="/mydeliveries" className="inheritLinkColor">
                                <DropdownItem><Package {...ic} /> Mes envois</DropdownItem>
                            </Link>
                            <DropdownItem divider />
                            <Link to="/messages" className="inheritLinkColor">
                                <DropdownItem>
                                    <MessageCircle {...ic} /> Messages{' '}
                                    <NotificationMessage isLoading={this.props.isLoading} notifications={this.props.notifications} />
                                </DropdownItem>
                            </Link>
                            <DropdownItem onClick={this.handleLogout}>
                                <LogOut {...ic} /> Déconnexion
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                </NavItem>
            );
        };

        /* ── Mobile drawer ── */
        const MobileDrawer = () => (
            <>
                <div className={`mobile-drawer-overlay ${isMenuOpen ? 'open' : ''}`} onClick={this.closeMenu} />
                <div className={`mobile-drawer ${isMenuOpen ? 'open' : ''}`}>
                    <div className="mobile-drawer__header">
                        <Link to="/home" className="mobile-drawer__brand" onClick={this.closeMenu}>eudeliv</Link>
                        <button className="mobile-drawer__close" onClick={this.closeMenu} aria-label="Fermer">
                            <X size={18} strokeWidth={2.5} />
                        </button>
                    </div>

                    {user && (
                        <Link to="/profil" className="mobile-drawer__user" onClick={this.closeMenu} style={{ textDecoration: 'none' }}>
                            <img src="/assets/images/profil.svg" alt="avatar" width="44" height="44"
                                style={{ borderRadius: '50%', border: '2px solid rgba(255,255,255,0.3)' }} />
                            <div>
                                <div className="mobile-drawer__user-name">{user.user.firstName} {user.user.lastName}</div>
                                <div className="mobile-drawer__user-sub">Voir mon profil →</div>
                            </div>
                            <NotificationMessage isLoading={this.props.isLoading} notifications={this.props.notifications} />
                        </Link>
                    )}

                    <nav className="mobile-drawer__nav">
                        {[
                            { to: '/searchannouncements', Icon: Search,        label: 'Rechercher une annonce'  },
                            { to: '/adddelivery',          Icon: Package,       label: 'Envoyer un colis'        },
                            { to: '/addtrip',              Icon: Route,         label: 'Transporter un colis'    },
                            { to: '/blog',                 Icon: Newspaper,     label: 'Blog'                    },
                        ].map(({ to, Icon, label }) => (
                            <Link key={to} to={to} className="mobile-drawer__item" onClick={this.closeMenu}>
                                <span className="mobile-drawer__item-icon"><Icon size={18} strokeWidth={1.8} /></span>
                                {label}
                            </Link>
                        ))}

                        {user && (
                            <>
                                <div className="mobile-drawer__divider"></div>
                                {[
                                    { to: '/mytrips',      Icon: Route,         label: 'Mes trajets'  },
                                    { to: '/mydeliveries', Icon: Package,       label: 'Mes envois'   },
                                    { to: '/messages',     Icon: MessageCircle, label: 'Messages'     },
                                ].map(({ to, Icon, label }) => (
                                    <Link key={to} to={to} className="mobile-drawer__item" onClick={this.closeMenu}>
                                        <span className="mobile-drawer__item-icon"><Icon size={18} strokeWidth={1.8} /></span>
                                        {label}
                                    </Link>
                                ))}
                                <div className="mobile-drawer__divider"></div>
                                <button className="mobile-drawer__item" onClick={this.handleLogout}>
                                    <span className="mobile-drawer__item-icon mobile-drawer__item-icon--red">
                                        <LogOut size={18} strokeWidth={1.8} />
                                    </span>
                                    <span style={{ color: '#e53935' }}>Se déconnecter</span>
                                </button>
                            </>
                        )}

                        {!user && (
                            <>
                                <div className="mobile-drawer__divider"></div>
                                <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                                    <Link to="/register" onClick={this.closeMenu}>
                                        <Button color="primary" block style={{ borderRadius: 50, fontWeight: 700 }}>S'inscrire gratuitement</Button>
                                    </Link>
                                    <Link to="/login" onClick={this.closeMenu}>
                                        <Button outline color="primary" block style={{ borderRadius: 50, fontWeight: 700 }}>Se connecter</Button>
                                    </Link>
                                </div>
                            </>
                        )}
                    </nav>
                </div>
            </>
        );

        const NAV_ITEMS = [
            { to: '/searchannouncements', Icon: Search,    label: 'Rechercher',           className: 'd-none d-lg-block' },
            { to: '/adddelivery',          Icon: Package,  label: 'Envoyer un colis'      },
            { to: '/addtrip',              Icon: Route,    label: 'Transporter un colis'  },
            { to: '/blog',                 Icon: Newspaper,label: 'Blog'                  },
        ];

        return (
            <>
                {hideNav ? (
                    <>
                        <div className="mobile-navbar">
                            <Link to="/home" className="mobile-navbar__brand">eudeliv</Link>
                            <button className="hamburger-btn" onClick={this.toggleMenu} aria-label="Menu">
                                <Menu size={20} strokeWidth={2} color="var(--dark)" />
                            </button>
                        </div>
                        <MobileDrawer />
                    </>
                ) : (
                    <Navbar light expand="md">
                        <NavbarBrand href="/home" style={{ lineHeight: '30px' }}>
                            <h2 className="d-inline-block ml-0 mb-0">
                                <span className="text-primary">eudeliv</span>
                            </h2>
                        </NavbarBrand>
                        <Nav className="ml-auto" navbar>
                            {NAV_ITEMS.map(({ to, Icon, label, className }) => (
                                <NavItem key={to} className={className}>
                                    <Link className="nav-link" to={to}>
                                        <Icon size={16} strokeWidth={2} color="#00AFF5" style={{ verticalAlign: 'middle', marginRight: 5 }} />
                                        <strong className="text-primary">{label}</strong>
                                    </Link>
                                </NavItem>
                            ))}
                            <DesktopUserMenu />
                        </Nav>
                    </Navbar>
                )}
            </>
        );
    }
}

export default Header;
